interface CurrentTransactionItemIdentifiers {
  id: number;
  selectedModifierOptions?: { id: number }[];
  selectedBundleOptions?: {
    id: number;
    quantity: number;
    selectedModifierOptions?: { id: number }[];
  }[];
}

  /**
   * Builds a stable key used to identify equivalent transaction items.
   *
   * Key format:
   *   Regular product:
   *     productId|modifierOptionIds|
   *
   *   Bundle product:
   *     productId||bundleItemKey;bundleItemKey
   *
   *   Bundle item format:
   *     bundleOptionId:quantity:modifierOptionIds
   *
   * Modifier and bundle item IDs are sorted so that selection order
   * does not affect the generated key.
   *
   * Examples:
   *
   *   Regular product #10 with no modifiers:
   *     10||
   *
   *   Regular product #10 with modifiers #2 and #5:
   *     10|2,5|
   *
   *   Bundle #20:
   *     - Bundle option #101 x2 with modifier #7
   *     - Bundle option #102 x1 with no modifiers
   *
   *     20||101:2:7;102:1:
   */
export function buildCurrentTransactionItemKey(
  product: CurrentTransactionItemIdentifiers,
): string {
  const modifierKey = (product.selectedModifierOptions ?? [])
    .map(option => option.id)
    .sort((a, b) => a - b)
    .join(',');

  const bundleKey = (product.selectedBundleOptions ?? [])
    .map(item => {
      const modifierKey = (item.selectedModifierOptions ?? [])
        .map(option => option.id)
        .sort((a, b) => a - b)
        .join(',');

      return [
        item.id,
        item.quantity, // Include quantity so bundle items with different quantities remain separate cart items.
        modifierKey,
      ].join(':');
    })
    .sort()
    .join(';');

  return [
    product.id,
    modifierKey,
    bundleKey,
  ].join('|');
}
